import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
//@ts-ignore
import useAuthStore from "@/store/Auth/useAuthStore";

// import { responsiveFontSizes } from "@mui/material/styles";
import resolveConfig from "tailwindcss/resolveConfig";
//@ts-ignore
import tailwindConfig from "../../tailwind.config.ts";

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isAr = useAuthStore((state) => state.direction === "ar");

  // @ts-ignore

  // Resolve the Tailwind config so you can access theme values
  const fullConfig = resolveConfig(tailwindConfig);

  // Safely grab the colors from the resolved config (using optional chaining in case something is missing)
  const twColors = fullConfig.theme?.colors as Record<string, string>;
  const twFonts = fullConfig.theme?.fontFamily as Record<string, string>;

  const theme = createTheme({
    palette: {
      primary: {
        main: twColors?.primary || "#00B8FF",
      },
      secondary: {
        main: twColors?.secondary || "#00B8FF",
      },
      success: {
        main: twColors?.success || "#00B8FF",
      },
      error: {
        main: twColors?.error || "#ff0000",
      },
    },
    typography: {
      fontFamily: `${isAr ? twFonts.MainFont : twFonts.sans} !important`,
      h1: {
        fontFamily: `${isAr ? twFonts.MainFont : twFonts.sans} !important`,
      },
      body1: {
        fontFamily: `${isAr ? twFonts.MainFont : twFonts.sans} !important`,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily: '"MainFont", "Arial", sans-serif',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: "MainFont",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            padding: "0.5rem 1rem !important",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: "MainFont",
            boxShadow: "none",
          },
        },
      },

      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontWeight: 400,
            color: "black",
            "&.Mui-focused": {
              color: "#333333",
              fontSize: "1rem",
              paddingTop: "0em",
            },
          },
          asterisk: {
            color: "black",
          },
        },
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            fontFamily: "MainFont",
            paddingBottom: "0.3rem",
            "& fieldset": {
              borderColor: "#d5d5d5",
            },
            padding: "0.3rem",
          },
          input: {
            fontSize: "1em ",
            "& fieldset": {
              borderColor: "#d5d5d5",
            },
            padding: "0.5rem",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            padding: "0.3rem",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          shrink: {
            top: "0rem !important",
          },
        },
      },

      MuiMenu: {
        defaultProps: {
          disableScrollLock: true,
        },
        styleOverrides: {
          list: {
            padding: "0rem",
          },
        },
      },

      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: "1rem !important",
          },
        },
      },

      MuiCheckbox: {
        styleOverrides: {
          root: {
            "&.Mui-checked .MuiSvgIcon-root": {
              fill: "#32d74b",
            },
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            border: "1px solid #EFF4F9",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:last-child td, &:last-child th": { border: 0 },
            "&:hover": {
              backgroundColor: "#f5f5f5 !important",
            },
          },
        },
      },
      MuiStepLabel: {
        styleOverrides: {
          iconContainer: {
            direction: "rtl",
            marginRight: "0.5rem",
          },
          label: {
            direction: "rtl",
            marginRight: "0.5rem",
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            maxHeight: "21em",
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            margin: "0rem !important",
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            padding: "1rem !important",
            paddingLeft: "0.5rem ",
            paddingRight: "0.5rem ",
          },
          container: {
            padding: "0rem !important",
            paddingLeft: "0rem !important",
            paddingRight: "0rem !important",
          },
        },
      },

      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            marginTop: "0.5rem !important",
            fontSize: "0.8rem",
            backgroundColor: "#F9A230 !important",
          },
          arrow: {
            color: "#F9A230 !important",
          },
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppThemeProvider;
